import { DELETE } from "../API/delete";
import { GET, GETDIRECTAPICALL } from "../API/get";
import { FORMPOST, POST } from "../API/post";
import { PUT } from "../API/put";
import genderOptions from "./components/accountCreated/genderOptions";

const IPINFO_URL = "https://api64.ipify.org?format=json";

export const submitRegistration = async ({
    ftm_forename,
    ftm_surname,
    ftm_email,
    ftm_password,
    ftm_contact_number,
    ftm_birth_of_date,
    ftm_gender,
    ftm_t_shirt_size
}) => {
    const gender = genderOptions.find(gender => gender.gender_id === ftm_gender);
    if (gender) {
        ftm_gender = gender.gender_id;
    }

    const response = await POST("ftms-register", {
        ftm_forename,
        ftm_surname,
        ftm_email,
        ftm_password,
        ftm_contact_number: ftm_contact_number.replace(/[^+\d]/g, ''),
        ftm_birth_of_date: new Date(ftm_birth_of_date).getTime(),
        ftm_gender,
        ftm_t_shirt_size_id: ftm_t_shirt_size,
    });

    return response.status === "Success" ? response : null;
}

export const fetchShirtSides = async () => {
    const response = await GET("ftm/t-shirt-size");
    return response.status === "Success" ? response : null;
}

export const fetchUnregisteredFtm = async (key) => {
    const response = await GET(`ftm/unregistered/${key}`);
    return response.status === "Success" ? response : null;
}

export const verifyOtp = async (ftm_id, ftm_otp, ftm_otp_type) => {
    const response = await PUT("ftms-register-verify", {
        ftm_id: ftm_id,
        ftm_otp: ftm_otp,
        ftm_otp_type: ftm_otp_type
    });

    return response.status === "Success" ? response : null;
};

export const fetchSettings = async (ftm_id) => {
    const response = await GET(`ftm/register/settings/${ftm_id}`);
    return response.status === "Success" ? response : null;
}

export const uploadProfileImage = async (ftm_id, file, onUploadProgress) => {
    const response = await FORMPOST("ftm/register/upload/profile-photo", {
        ftm_id: ftm_id,
        profile_image: file
    }, onUploadProgress);

    return response?.status === "Success" ? response : null;
};

export const fetchPostcodeAddress = async (label) => {
    const response = await GET(`postcode/address/details/${label}`);
    return response.status === "Success" ? response : null;
}

export const fetchPostcodeAddressList = async (value) => {
    const response = await GET(`postcode/address/list/${value}`);
    return response.status === "Success" ? response : null;
}

export const updatePersonalInformation = async (data) => {
    console.log("🚀 ~ updatePersonalInformation ~ data:", data)
    const response = await PUT("ftm/registration/personal-information", data);
    return response.status === "Success" ? response : null;
};

export const fetchSkillsWithSubSkills = async () => {
    const response = await GET("skills-with-subskills");
    return response.status === "Success" ? response : null;
}

export const updateFtmSkills = async (data) => {
    const response = await POST("ftm/registration/skills", data);
    return response.status === "Success" ? response : null;
};

export const fetchPaymentTerms = async () => {
    const response = await GET("ftm/payment-terms");
    return response.status === "Success" ? response : null;
}

export const updateFtmPaymentTerms = async (data) => {
    const response = await PUT("ftm/payment-term", data);
    return response.status === "Success" ? response : null;
};

export const fetchDocumentTypes = async (ftm_id) => {
    const response = await GET(`ftm/unregistered/document/types/${ftm_id}`);
    return response.status === "Success" ? response : null;
}

export const fetchDocuments = async (ftm_id, document_type_id) => {
    const response = await GET(`ftm/unregistered/documents/${ftm_id}/${document_type_id}`);
    return response.status === "Success" ? response : null;
}

export const uploadDocuments = async ({ ftm_id, ftm_document_type_id, ftm_document_type, document_type, ftm_document }) => {
    const response = await FORMPOST(`upload-ftm-documents`, {
        ftm_id,
        ftm_document_type_id,
        ftm_document_type,
        ftm_is_registering: 1,
        document_type,
        ftm_document,
        is_ftm_web_registration: 1
    });

    return response.status === "Success" ? response : null;
}

export const fetchDocumentTypeslist = async (ftm_id) => {
    const response = await GET(`personal-document-types/${ftm_id}`);
    return response.status === "Success" ? response : null;
}

export const fetchPersonalDocumentTypeslist = async (ftm_id, documents_types_id) => {
    const response = await GET(`ftm/unregistered/personal/documents/${ftm_id}/${documents_types_id}`);
    return response.status === "Success" ? response : null;
}

export const checkFtmDocuments = async (ftm_id) => {
    const response = await PUT("ftm/unregistered/check/personal/documents", { ftm_id });
    return response.status === "Success" ? response : null;
};

export const checkFtmCertificates = async (ftm_id) => {
    const response = await PUT("ftm/unregistered/check/certificates/documents", { ftm_id });
    return response.status === "Success" ? response : null;
};

export const fetchTermsAndConditions = async () => {
    const response = await GET(`ftm/registration/terms-and-conditions`);
    return response.status === "Success" ? response : null;
}

export const fetchIp = async () => {
    const response = await GETDIRECTAPICALL(`${IPINFO_URL}`);
    return response?.status === "Success" ? response : null;
}

export const updateFtmTermsAndConditions = async (ftm_id, user_ip) => {
    const response = await PUT("ftm/registration/terms-and-conditions", { ftm_id, user_ip });
    return response.status === "Success" ? response : null;
};

export const fetchCompletedDetails = async () => {
    const response = await GET("ftm/registration/completed/details");
    return response.status === "Success" ? response : null;
};

export const fetchResendOtp = async (ftm_id, ftm_otp_type) => {
    const response = await GET(`ftm/resend/auth/code/${ftm_id}/1/${ftm_otp_type}`);
    return response.status === "Success" ? response : null;
}

export const fetchRegistrationTemporaryToken = async (key) => {
    const response = await GET(`ftm/registration/temporary-token/${key}`);
    return response.status === "Success" ? response : null;
}

export const deleteCertificate = async (document_file_id) => {
    const response = await DELETE(`ftm/document/${document_file_id}`);
    return response.status === "Success" ? response : null;
};

export const deletePersonalDocument = async (personal_document_file_id) => {
    const response = await DELETE(`ftm/personal/document/${personal_document_file_id}`);
    return response.status === "Success" ? response : null;
};

export const fetchCommonSettings = async () => {
    const response = await GET(`common/settings/FTM`);
    return response.status === "Success" ? response : null;
}

export const updatePhoneNumberVerification = async (ftm_id, ftm_contact_number) => {
    const response = await PUT("ftm/update-phone-number-verification", { ftm_id, ftm_contact_number: ftm_contact_number.replace(/[^+\d]/g, '') });
    return response.status === "Success" ? response : null;
};

export const updateEmailVerification = async (ftm_id, ftm_email) => {
    const response = await PUT("ftm/update-email-verification", { ftm_id, ftm_email });
    return response.status === "Success" ? response : null;
};

export const temporaryLogin = async (temporary_token) => {
    const response = await POST("ftm/temporary/login", {
        temporary_token: temporary_token
    });
    return response.status === "Success" ? response : null;
};

export const fetchLoginQrCode = async (key) => {
    const response = await GET(`ftm/unregistered/login/qr-code/${key}`);
    return response.status === "Success" ? response : null;
}

export const ftmTemporaryToken = async (key) => {
    const response = await POST("ftm/temporary/token", {
        key: key
    });
    return response.status === "Success" ? response : null;
}

export const fetchVehicleModels = async (brand) => {
    const response = await GETDIRECTAPICALL(`https://vpic.nhtsa.dot.gov/api/vehicles/getmodelsformake/${brand}?format=json`);
    return response?.status === "Success" ? response : null;
}